import React, { useState } from 'react'

import { useHistory } from 'react-router-dom'
import { reverse } from 'named-urls'
import PropTypes from 'prop-types'

import { MenuButton, Permitted, ButtonAction } from 'components'
import { ChangeStatusDialog } from './components'

import useSnackbar from 'hooks/useSnackbar'

import { routes } from 'Routes'
import helpers from 'helpers'
import * as service from 'service'
import constants from 'constants/index'

const Actions = ({ userCompany, refresh, profiles }) => {
  const [changeStatusDialog, setChangeStatusDialog] = useState(false)
  const [inactivate, setInactivate] = useState(false)
  const [notifying, setNotifying] = useState(false)

  const history = useHistory()
  const snackbar = useSnackbar()

  const isActive = userCompany?.status === constants.userCompanies.ACTIVE

  const disableActionBySupplier =
    userCompany?.responsable &&
    userCompany?.profile?.id === constants.profile.SUPPLIER_ID

  const navigateToEdit = () => {
    history.push(
      reverse(routes.user.edit, {
        userId: userCompany?.user?.id,
      }),
    )
  }

  const handleChangeStatus = () => {
    setChangeStatusDialog(true)
  }

  const handleInactivate = () => {
    setInactivate(true)
    setChangeStatusDialog(true)
  }

  const handleNotifyUser = async () => {
    setNotifying(true)
    try {
      await service.dponet.trainningJourneys.notifyPendingTrainnings({
        userIds: [userCompany?.user?.id],
      })

      snackbar.open({
        message:
          'Será enviado um e-mail de notificação para o usuário sobre seus treinamentos pendentes.',
        variant: 'success',
      })
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Erro ao enviar notificação',
        variant: 'error',
      })
    } finally {
      setNotifying(false)
    }
  }

  return (
    <>
      <Permitted
        someTags={[
          constants.permissions.USERS.EDIT,
          constants.permissions.USERS.SOFT_DELETE,
          constants.permissions.TRAINNING_JOURNEYS.MANAGE,
        ]}
      >
        <MenuButton id={constants.user.USER_MAIN_DRIVER_STEP_3}>
          {isActive && (
            <Permitted tag={constants.permissions.USERS.EDIT}>
              <ButtonAction
                color="secondary"
                action={navigateToEdit}
                fullWidth
                size="small"
                name="Editar"
                disabled={disableActionBySupplier}
              />
            </Permitted>
          )}
          <Permitted tag={constants.permissions.USERS.SOFT_DELETE}>
            <ButtonAction
              color="secondary"
              action={handleChangeStatus}
              fullWidth
              size="small"
              name="Excluir"
              disabled={disableActionBySupplier}
            />
          </Permitted>
          <Permitted tag={constants.permissions.USERS.EDIT}>
            <ButtonAction
              color="secondary"
              action={handleInactivate}
              fullWidth
              size="small"
              name={isActive ? 'Inativar' : 'Ativar'}
              disabled={disableActionBySupplier}
            />
          </Permitted>
          {isActive && (
            <Permitted tag={constants.permissions.TRAINNING_JOURNEYS.MANAGE}>
              <ButtonAction
                color="secondary"
                action={handleNotifyUser}
                fullWidth
                size="small"
                name="Notificar treinamentos pendentes"
                disabled={notifying}
              />
            </Permitted>
          )}
        </MenuButton>
      </Permitted>
      {changeStatusDialog && (
        <ChangeStatusDialog
          inactivateUser={inactivate}
          setInactivateUser={setInactivate}
          open={changeStatusDialog}
          refresh={refresh}
          profiles={profiles}
          setOpen={setChangeStatusDialog}
          user={userCompany?.user}
          userCompanyStatus={userCompany?.status}
          userCompanyId={userCompany?.id}
          isNotSupplier={
            userCompany?.company?.kind !== constants.company.SUPPLIER_KIND
          }
          isNotGovernanceProjectUser={
            !constants.profile.GOVERNANCE_PROJECT_PROFILES.includes(
              userCompany?.profile?.id,
            )
          }
        />
      )}
    </>
  )
}

Actions.propTypes = {
  userCompany: PropTypes.object,
  refresh: PropTypes.func,
  profiles: PropTypes.array,
}

Actions.defaultProps = {
  refresh: () => {},
}

export default Actions
